import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare,faComment,faFolderOpen,faFilePen,faTrash, faRotateLeft } from '@fortawesome/free-solid-svg-icons';
import SlideTask from '../UserComponents/SlideTask';
import AcademicGuruLogo from '../assets/academicguru.png';
import LeelagreenLogo from '../assets/leelagreen.jpg';
import AGPHLogo from '../assets/agph.png';
import IJISEMLogo from '../assets/ijisem.png';

const RecycleBin = () => {
  const [projects, setProjects] = useState([]);
  const [expandedProjectIds, setExpandedProjectIds] = useState([]);
    const [userprojectOptions, setUserprojectOptions] = useState([]);
      const [userMap, setUserMap] = useState({});
        const [singletasks, setsingleTasks] = useState([]);
        const [showSidebar, setShowSidebar] = useState(false);
          const [selectedRowData, setSelectedRowData] = useState(null);

  useEffect(() => {
    axios.get('/api/recycle_task.php', {
      withCredentials: true,
    })
    .then(response => {
      setsingleTasks(response.data);
    })
    .catch(error => {
      console.error('Error fetching tasks:', error);
    });
  }, []);
    

      useEffect(() => {
        const fetchUserNames = async () => {
          try {
            const res = await axios.get("/api/useroptions.php");
            const map = {};
            res.data.forEach(user => {
              map[user.id] = user.name; // 🔄 changed from user.user_id to user.id
            });
            setUserMap(map);
          } catch (error) {
            console.error("Failed to load user names:", error);
          }
        };
        fetchUserNames();
      }, []);

    useEffect(() => {
    const fetchUsersproject = async () => {
      try {
        const res = await axios.get("/api/users.php");
        setUserprojectOptions(res.data);
      } catch (error) {
        console.error("Failed to load users:", error);
      }
    };

    fetchUsersproject();
  }, []);
  

  useEffect(() => {
  axios.get('/api/recycle_project.php')
    .then(res => {
      console.log(res.data); // Add this line to debug shape
      setProjects(res.data); // Make sure this is the array
    })
    .catch(err => console.error('Error fetching projects:', err));
}, []);


  const toggleProject = (projectId) => {
    setExpandedProjectIds(prev =>
      prev.includes(projectId)
        ? prev.filter(id => id !== projectId)
        : [...prev, projectId]
    );
  };

  const renderTaskStatusSquares = (taskCountJson) => {
    let parsed = {
      "Hold": 0,
      "To Do": 0,
      "Doing": 0,
      "Done": 0
      
    };
  
    try {
      if (typeof taskCountJson === 'string') {
        const temp = JSON.parse(taskCountJson);
        parsed = { ...parsed, ...temp };
      } else if (typeof taskCountJson === 'object' && taskCountJson !== null) {
        parsed = { ...parsed, ...taskCountJson };
      }
    } catch (e) {
      // fail silently
    }
  
    const colorMap = {
      'Hold': 'text-gray-300',
      'To Do': 'text-red-300',
      'Doing': 'text-yellow-300',
      'Done': 'text-green-300',
      
      
    };
  
    return (
      <div className="flex flex-wrap gap-0.5">
        {['Hold','To Do', 'Doing', 'Done'].map((key) =>
          parsed[key] > 0
            ? [...Array(parsed[key])].map((_, idx) => (
                <FontAwesomeIcon
                  key={`${key}-${idx}`}
                  icon={faSquare}
                  className={`text-[9px] ${colorMap[key]}`}
                />
              ))
            : null
        )}
      </div>
    );
  };

  const handleRestore = async (projectId) => {
  if (!window.confirm("Are you sure you want to restore this project?")) return;

  try {
    const response = await axios.post(
      "/api/restore_project.php",
      { project_id: projectId },
      { withCredentials: true }
    );
    alert(response.data.message);
    // Optionally, refetch the list:
    setProjects(projects.filter(p => p.project_id !== projectId));
  } catch (error) {
    console.error("Restore failed:", error);
    alert("Failed to restore project.");
  }
};

const handleDelete = async (projectId) => {
  if (!window.confirm("Are you sure you want to permanently delete this project?")) return;

  try {
    const response = await axios.post(
      "/api/delete_recycle_project.php",
      { project_id: projectId },
      { withCredentials: true }
    );
    alert(response.data.message);
    setProjects(projects.filter(p => p.project_id !== projectId));
  } catch (error) {
    console.error("Delete failed:", error);
    alert("Failed to delete project.");
  }
};

const handleTaskRestore = async (taskId) => {
  try {
    const res = await axios.post('/api/restore_single_task.php', {
      task_id: taskId,
    });
    console.log(res.data.message);
    // Refresh task list or remove restored task from UI
    setsingleTasks(prev => prev.filter(task => task.task_id !== taskId));
  } catch (err) {
    console.error('Restore failed:', err);
  }
};

const handleTaskDelete = async (taskId) => {
  try {
    const res = await axios.post('/api/delete_single_task.php', {
      task_id: taskId,
    });
    console.log(res.data.message);
    // Refresh task list or remove deleted task from UI
    setsingleTasks(prev => prev.filter(task => task.task_id !== taskId));
  } catch (err) {
    console.error('Delete failed:', err);
  }
};



  return (
    <div className="p-6">
      <h2 className="text-xl text-gray-700 font-semibold mb-4">Recycle Bin</h2>
      <p className='font-semibold text-gray-500 my-2'><FontAwesomeIcon icon={faFolderOpen} className='text-yellow-500 mr-1 '/>Project</p>
      <table className="w-full  rounded-sm overflow-hidden shadow-xl">
        <thead className="bg-gray-700 font-medium text-gray-100 text-left text-xs uppercase whitespace-nowrap">
          <tr className='font-medium'>
            <th></th>
            <th className="p-2">Project ID</th>
            <th className="p-2">Project Name</th>
            <th className="p-2">Client</th>
            <th className="p-2">Category</th>
            <th className="p-2">Manage By</th>
            <th className="p-2">Assignees</th>
            <th className="p-2">Progress</th>
            <th className="p-2">DeadLine</th>
            <th className="p-2">Action</th>
          </tr>
        </thead>
        <tbody>
          {projects.map((project) => (
            <React.Fragment key={project.id}>
              <tr
                onClick={() => toggleProject(project.project_id)}
                className="cursor-pointer hover:bg-gray-50 text-xs"
              >
<td className='p-2'>
  {(() => {
    const companyLogoMap = {
      'IJISEM': IJISEMLogo,
      'Academic Guru': AcademicGuruLogo,
      'Leela Greens': LeelagreenLogo,
      'AGPH': AGPHLogo,
    };
    const logo = companyLogoMap[project.company_name];
    return logo ? (
      <img
        src={logo}
        alt={project.company_name}
        className="h-4 w-4 rounded-full"
        title={project.company_name}
      />
    ) : (
      <span>{project.company_name}</span>
    );
  })()}
</td>
                <td className="px-1 py-3">{project.project_id}</td>
                <td className="px-1 py-3">{project.name}</td>
                <td className="px-1 py-3">{project.client}</td>
                <td className="px-1 py-3">{project.category}</td>
                 <td className="px-3 py-3">
                  {userprojectOptions.find(u => u.name === project.assign_to)?.name || 'Unknown'}
                </td>
                
                  <td className="pl-3">
  {Array.isArray(project.members) && project.members.length > 0 && (
    <span
      className="inline-flex items-center justify-center w-6 h-6 rounded-full text-xs font-semibold text-gray-700 bg-gray-200"
      title={project.members.map((m) => userMap[m] || m).join(', ')}
    >
      {project.members.length}
    </span>
  )}
</td>

                  <td className="px-3 py-3 text-sm">
                  {renderTaskStatusSquares(project.no_of_task)}
                </td>
                  <td
                    className={`px-3 py-3  transition-all duration-300 ${
                      project.submisssion_date &&
                      (() => {
                        const today = new Date();
                        const submissionDate = new Date(project.submisssion_date);
                        const diffInDays = Math.ceil((submissionDate - today) / (1000 * 60 * 60 * 24));                  

                        return diffInDays <= 2 ? 'text-red-600 font-semibold' : '';
                      })()
                    }`}
                  >
                    {project.submisssion_date
                      ? `${new Date(project.submisssion_date).toLocaleDateString('en-GB')}${
                          (() => {
                            const today = new Date();
                            const submissionDate = new Date(project.submisssion_date);
                            const diffInDays = Math.ceil((submissionDate - today) / (1000 * 60 * 60 * 24));                  

                            return diffInDays <= 2 ? ' ' : '';
                          })()
                        }`
                      : ''}
                  </td>
                  <td className='text-center text-sm space-x-2'>
                    <button onClick={() => handleRestore(project.project_id)} title="Restore">
                      <FontAwesomeIcon icon={faRotateLeft} className="text-green-500 hover:text-green-700" />
                    </button>
                    <button onClick={() => handleDelete(project.project_id)} title="Delete">
                      <FontAwesomeIcon icon={faTrash} className="text-red-500 hover:text-red-700" />
                    </button>
                  </td>

              </tr>

              {expandedProjectIds.includes(project.project_id) && (
                <tr>
                  <td colSpan="10" className="bg-gray-50 p-2">
                    <p className='font-semibold text-gray-500 text-sm'> <FontAwesomeIcon icon={faFolderOpen} className='text-yellow-500 mr-1'/>Tasks</p>
                    <TaskTable projectId={project.project_id} />
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>

      <div className=" ">
      <h2 className="text-sm text-gray-500  font-semibold my-4 mt-8"><FontAwesomeIcon icon={faFilePen}  className='text-red-300 text-sm mr-1'/>Single Tasks</h2>
      <div className='rounded-lg shadow-xl'>
      <table className="bg-white border border-gray-200 rounded min-w-233 ">
        <thead className='bg-gray-700  text-gray-100 uppercase whitespace-nowrap'>
          <tr className="">
            <th className="p-2 px-4 text-[11px]">Task ID</th>
          <th className="p-2 px-4 text-[11px]">Task Name</th>
          <th className="p-2 px-4 text-[11px]">Assign To</th>
          <th className="p-2 px-4 text-[11px]">Priority</th>
          <th className="p-2 px-4 text-[11px]">Start Date</th>
          <th className="p-2 px-4 text-[11px]">Tentative Time</th>
          <th className="p-2 px-4 text-[11px]">Submission date</th>
          <th className="p-2 px-4 text-[11px]">Action</th>
          </tr>
        </thead>
        <tbody>
          {singletasks.length === 0 ? (
            <tr>
              <td colSpan="8" className="text-center py-4 text-gray-700 text-sm">No tasks found</td>
            </tr>
          ) : (
            singletasks.map((singletask, index) => (
              <tr key={index} 
              onClick={() => {
                            setSelectedRowData(singletask); // row.original has full raw data
                            setShowSidebar(true);
                          }}
              className="hover:bg-gray-50 text-gray-700 text-xs">
                <td className="p-3 px-4 ">{singletask.task_id}</td>
              <td className="p-3 px-4 ">{singletask.task_name}</td>
              <td className="p-3 px-4 flex gap-2">{singletask.assign_to} 
                <button className="relative">
      <FontAwesomeIcon icon={faComment} />
      {(() => {
        let commentArray = [];
        const rawComment = singletask.comment;
        if (typeof rawComment === "string") {
          try {
            const parsed = JSON.parse(rawComment);
            commentArray = Array.isArray(parsed) ? parsed : [parsed];
          } catch {
            commentArray = rawComment ? [rawComment] : [];
          }
        } else if (Array.isArray(rawComment)) {
          commentArray = rawComment;
        } else if (rawComment) {
          commentArray = [rawComment];
        }
        const commentCount = commentArray.length;
        return commentCount > 0 ? (
          <span className="absolute bottom-4 left-3 bg-gray-600 text-white rounded-full text-[0.45rem] px-1">
            {commentCount}
          </span>
        ) : null;
      })()}
    </button>
              </td>
         

  {/* Priority */}
  <td className="p-2 px-4">
    {(() => {
      const value = singletask.priority;
      let bgColor = "transparent";
      let textColor = "inherit";
      if (value === "Medium") {
        bgColor = "#d1fae5"; // green-100
      } else if (value === "Urgent") {
        bgColor = "#f87171"; // red-400
        textColor = "white";
      }
      return (
        <div
          style={{
            fontSize: "12px",
            textAlign: "center",
            borderRadius: "10px",
            backgroundColor: bgColor,
            color: textColor,
          }}
          className="mx-1"
        >
          {value}
        </div>
      );
    })()}
  </td>

  {/* Start Date */}
  <td className="p-2 px-4">
    {singletask.start_date
      ? (() => {
          const date = new Date(singletask.start_date);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        })()
      : ""}
  </td>

  {/* Time (submission_date field) */}
  <td className="p-2 px-4">{singletask.submission_date ? `${singletask.submission_date} hr` : ""}</td>

  {/* Due Date */}
  <td className="p-2 px-4">
    {singletask.due_date
      ? (() => {
          const date = new Date(singletask.due_date);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        })()
      : ""}
  </td>
  <td className='text-center text-sm'> 
    <td className="text-center text-sm">
  <FontAwesomeIcon
    icon={faRotateLeft}
    className="text-green-500 mr-2 cursor-pointer"
    onClick={(e) => {
      e.stopPropagation(); // prevent triggering row click
      handleTaskRestore(singletask.task_id);
    }}
    title="Restore Task"
  />
  <FontAwesomeIcon
    icon={faTrash}
    className="text-red-500 cursor-pointer"
    onClick={(e) => {
      e.stopPropagation();
      handleTaskDelete(singletask.task_id);
    }}
    title="Delete Task"
  />
</td>

  </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
              <SlideTask
                  show={showSidebar}
                  onClose={() => setShowSidebar(false)}
                  data={selectedRowData}
                />
      </div>
    </div>
    </div>
  );
};

const TaskTable = ({ projectId }) => {
  const [tasks, setTasks] = useState([]);
      const [showSidebar, setShowSidebar] = useState(false);
          const [selectedRowData, setSelectedRowData] = useState(null);

        
      
  

  useEffect(() => {
    axios.get(`/api/recycle_task.php?project_id=${projectId}`)
      .then(res => setTasks(res.data))
      .catch(err => console.error(`Error fetching tasks for ${projectId}:`, err));
  }, [projectId]);

  return (
    <div className='flex pl-5 my-4'>
        
        <div className='border-l border-dotted border-gray-500 '>
            <table className="w-full ">
      <thead className="">
        <tr>
          <th className="p-4 px-0 text-sm"></th>
          
        </tr>
      </thead>
      <tbody>
        {tasks.length === 0 ? (
          <tr></tr>
        ) : (
          tasks.map((task) => (
            <tr key={task.id} className="">
              
              <td className="p-2 text-sm">.........</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
        </div>
        <div className='rounded-sm  '>
            <table className=" bg-white border border-gray-200 rounded">
      <thead className="bg-gray-700  text-gray-100 uppercase whitespace-nowrap">
        <tr>
          <th className="p-2 px-4 text-[11px]">Task ID</th>
          <th className="p-2 px-4 text-[11px]">Task Name</th>
          <th className="p-2 px-4 text-[11px]">Assign To</th>
          <th className="p-2 px-4 text-[11px]">Priority</th>
          <th className="p-2 px-4 text-[11px]">Start Date</th>
          <th className="p-2 px-4 text-[11px]">Tentative Time</th>
          <th className="p-2 px-4 text-[11px]">Submission date</th>
        </tr>
      </thead>
      <tbody>
        {tasks.length === 0 ? (
          <tr><td colSpan="4" className="p-2 text-gray-400">No tasks</td></tr>
        ) : (
          tasks.map((task) => (
            <tr key={task.id}
                          onClick={() => {
                            setSelectedRowData(task); // row.original has full raw data
                            setShowSidebar(true);
                          }}
            className="border-b border-gray-200 text-xs text-gray-600">
              <td className="p-2 px-4 ">{task.task_id}</td>
              <td className="p-2 px-4 ">{task.task_name}</td>
              <td className="p-2 px-4 flex gap-2">{task.assign_to} 
                <button className="relative">
      <FontAwesomeIcon icon={faComment} />
      {(() => {
        let commentArray = [];
        const rawComment = task.comment;
        if (typeof rawComment === "string") {
          try {
            const parsed = JSON.parse(rawComment);
            commentArray = Array.isArray(parsed) ? parsed : [parsed];
          } catch {
            commentArray = rawComment ? [rawComment] : [];
          }
        } else if (Array.isArray(rawComment)) {
          commentArray = rawComment;
        } else if (rawComment) {
          commentArray = [rawComment];
        }
        const commentCount = commentArray.length;
        return commentCount > 0 ? (
          <span className="absolute bottom-4 left-3 bg-gray-600 text-white rounded-full text-[0.45rem] px-1">
            {commentCount}
          </span>
        ) : null;
      })()}
    </button>
              </td>
         

  {/* Priority */}
  <td className="p-2 px-4">
    {(() => {
      const value = task.priority;
      let bgColor = "transparent";
      let textColor = "inherit";
      if (value === "Medium") {
        bgColor = "#d1fae5"; // green-100
      } else if (value === "Urgent") {
        bgColor = "#f87171"; // red-400
        textColor = "white";
      }
      return (
        <div
          style={{
            fontSize: "12px",
            textAlign: "center",
            borderRadius: "10px",
            backgroundColor: bgColor,
            color: textColor,
          }}
          className="mx-1"
        >
          {value}
        </div>
      );
    })()}
  </td>

  {/* Start Date */}
  <td className="p-2 px-4">
    {task.start_date
      ? (() => {
          const date = new Date(task.start_date);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        })()
      : ""}
  </td>

  {/* Time (submission_date field) */}
  <td className="p-2 px-4">{task.submission_date ? `${task.submission_date} hr` : ""}</td>

  {/* Due Date */}
  <td className="p-2 px-4">
    {task.due_date
      ? (() => {
          const date = new Date(task.due_date);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        })()
      : ""}
  </td>
            </tr>
          ))
        )}
      </tbody>
    </table>

    
        </div>
        <SlideTask
                  show={showSidebar}
                  onClose={() => setShowSidebar(false)}
                  data={selectedRowData}
                />

        

    </div>

    
  );
};

export default RecycleBin;
